document.addEventListener('DOMContentLoaded', () => {
  // 1. Inizializzazione icone e scroll (Lenis)
  lucide.createIcons();
  const lenis = new Lenis();
  function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // 2. Registrazione plugin GSAP
  gsap.registerPlugin(ScrollTrigger);

  // 3. Animazione HERO (SplitType per le parole)
  const heroTitle = document.querySelector('.hero__title');
  if (heroTitle) {
      const childSplit = new SplitType(heroTitle, { types: 'words' });

      gsap.from(childSplit.words, {
          opacity: 0,
          y: 80,
          rotate: 5,
          duration: 1.2,
          stagger: 0.05,
          ease: "expo.out",
          clearProps: "all"
      });
  }

  // 4. Animazioni universali per le sezioni
  const fadeElements = gsap.utils.toArray('section:not(.hero)');

  fadeElements.forEach(section => {
      const targets = section.querySelectorAll('.section-title, .section-text, .feature-card, .growth-step, .insight-card, .check-list li');

      if (targets.length > 0) {
          gsap.to(targets, {
              scrollTrigger: {
                  trigger: section,
                  start: "top 80%",
                  toggleActions: "play none none none"
              },
              opacity: 1,
              y: 0,
              duration: 0.8,
              stagger: 0.15,
              ease: "power2.out"
          });
      }
  });

  // 5. Menu Mobile
  const burger = document.querySelector('.burger');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (burger && mobileMenu) {
      const toggleMenu = () => {
          burger.classList.toggle('burger--active');
          mobileMenu.classList.toggle('mobile-menu--active');
          document.body.style.overflow = mobileMenu.classList.contains('mobile-menu--active') ? 'hidden' : '';
      };

      burger.addEventListener('click', toggleMenu);
      document.querySelectorAll('.mobile-menu__link').forEach(link => {
          link.addEventListener('click', toggleMenu);
      });
  }

  // 6. Modulo di contatto e validazione
  const phoneInput = document.getElementById('phoneInput');
  if (phoneInput) {
      phoneInput.addEventListener('input', (e) => {
          // Permette solo numeri
          e.target.value = e.target.value.replace(/\D/g, '');
      });
  }

  const contactForm = document.getElementById('contactForm');
  if (contactForm) {
      // Captcha dinamico
      const n1 = Math.floor(Math.random() * 7) + 1;
      const n2 = Math.floor(Math.random() * 5) + 1;
      const captchaLabel = document.getElementById('captchaLabel');
      const correctResult = n1 + n2;

      if(captchaLabel) captchaLabel.innerText = `${n1} + ${n2} = ?`;

      contactForm.addEventListener('submit', (e) => {
          e.preventDefault();
          const status = document.getElementById('formStatus');
          const userAns = document.getElementById('captchaInput').value;

          if (parseInt(userAns) !== correctResult) {
              status.innerText = "Errore nel captcha!";
              status.style.color = "#ff4d4d";
              return;
          }

          status.innerText = "Invio in corso...";
          status.style.color = "#C5A059";

          setTimeout(() => {
              status.innerText = "Richiesta ricevuta con successo!";
              status.style.color = "#4CAF50";
              contactForm.reset();
          }, 1500);
      });
  }

  // 7. Cookie Popup (Aggiornato per Flex-Touchz)
  const cp = document.getElementById('cookiePopup');
  const storageKey = 'cookies_flex_touchz';

  if (cp && !localStorage.getItem(storageKey)) {
      cp.style.display = 'flex';
      document.getElementById('acceptCookies').onclick = () => {
          localStorage.setItem(storageKey, 'true');
          cp.style.display = 'none';
      };
  }

  ScrollTrigger.refresh();
});